/** Runtime node types and layout constants for the page renderer. */

import pageNodeTypes from './pageNodeTypes.json';

export const LAYOUT_BREAKPOINTS = ['mobile', 'tablet', 'desktop'];

export const DEFAULT_TRACKS = 12;

export const BREAKPOINT_MIN_WIDTH = {
  tablet: 600,
  desktop: 960,
};

export const HEIGHT_POLICIES = ['auto', 'compact', 'capped', 'fixed'];

export const NODE_TYPES = pageNodeTypes.nodeTypes;

export const NODE_TYPE_ALIAS_MAP = pageNodeTypes.aliases;

const NODE_TYPE_ALIASES = Object.keys(NODE_TYPE_ALIAS_MAP);

const ALLOWED_NODE_TYPE_SET = new Set([...NODE_TYPES, ...NODE_TYPE_ALIASES]);

export function isAllowedNodeType(nodeType) {
  return ALLOWED_NODE_TYPE_SET.has(String(nodeType || ''));
}

export function pageNodesForPage(nodes, pageId) {
  return Object.values(nodes || {}).map((node) => ({
    ...node,
    pageId,
  }));
}

/**
 * Prop names a Vue constructor (or options object) declares.
 * Used so persisted node.props never v-bind unknown keys onto the root.
 */
export function declaredNodePropKeys(component) {
  if (!component) return [];
  const options = component.options || component;
  const props = options.props;
  if (!props) return [];
  if (Array.isArray(props)) return props.map((name) => String(name));
  return Object.keys(props);
}

/**
 * Keep only keys the target node component declares. Drop onclick / onerror
 * and any other extra persisted field so they cannot land as attrs.
 */
export function pickDeclaredNodeProps(component, props) {
  if (!props || typeof props !== 'object') return {};
  const allowed = new Set(declaredNodePropKeys(component));
  if (!allowed.size) return {};
  const picked = {};
  Object.keys(props).forEach((key) => {
    if (allowed.has(key)) picked[key] = props[key];
  });
  return picked;
}
